import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { useTheme } from '../../contexts/ThemeContext';
import './LoadingSpinner.css';

const messages = {
  default: ['جارٍ التحميل', 'Loading'],
  page: ['نجهّز لك الصفحة', 'Getting your page ready'],
  post: ['جارٍ تحميل المنشور', 'Loading your post'],
  comments: ['جارٍ تحميل التعليقات', 'Loading comments'],
  poll: ['جارٍ تحميل الاستطلاع', 'Loading the poll'],
  video: ['جارٍ تحميل الفيديو', 'Loading the video'],
  quiz: ['جارٍ تجهيز الاختبار', 'Preparing your quiz'],
  reading: ['جارٍ تجهيز موضع القراءة', 'Preparing your reading position'],
};

export default function LoadingSpinner({ message, kind = 'default', overlay = false, fullPage = false, size = 'medium' }) {
  const { language } = useLanguage();
  const { theme } = useTheme() || {};
  const ar = language === 'ar';
  const label = message ?? (messages[kind] || messages.default)[ar ? 0 : 1];
  const content = <div className={'loading-spinner-container ' + size + (theme === 'dark' ? ' is-dark' : '') + (fullPage ? ' is-page' : '')}
    role="status" aria-live="polite" aria-atomic="true" dir={ar ? 'rtl' : 'ltr'} lang={ar ? 'ar' : 'en'}>
    <div className="loading-brand-mark" aria-hidden="true"><span/><img src="/assets/icons/icon-192x192.png" alt=""/></div>
    <span className="loading-brand-name" aria-hidden="true">AMPOSTER</span>
    <div className="loading-copy"><p className="loading-message">{label}</p><p className="loading-hint">{ar ? 'لحظات ويصبح كل شيء جاهزاً.' : 'Everything will be ready in a moment.'}</p></div>
    <div className="loading-progress-track" aria-hidden="true"><span/></div>
  </div>;
  return overlay ? <div className={'loading-spinner-overlay' + (theme === 'dark' ? ' is-dark' : '')}>{content}</div> : content;
}

